import React, { useRef, useState } from 'react';
import { CSSProperties } from 'styled-components';
import {
  SearchInputButton,
  SearchInputIconContainer,
  SearchInput as SearchInputStyled,
} from './SearchInputStyled';
import { Search, X } from 'react-bootstrap-icons';

type Props = {
  placeholder?: string;
  className?: string;
  id?: string;
  name?: string;
  style?: CSSProperties;
  type?: string;
  value?: string;
  'data-testid'?: string;
  onInput?: (value: string) => void;
};

export const SearchInput: React.FC<Props> = ({ onInput, value, ...rest }) => {
  const [showClear, setShowClear] = useState(false);
  const inputRef = useRef<HTMLInputElement | null>(null);

  function clearInput() {
    onInput?.('');
    if (inputRef.current) inputRef.current.value = '';
    setShowClear(false);
  }

  return (
    <SearchInputStyled>
      <input
        onInput={(e) => {
          setShowClear(e.currentTarget.value?.length > 0 ?? false);
          onInput?.(e.currentTarget.value);
        }}
        value={value}
        {...rest}
        ref={inputRef}
      />
      <SearchInputIconContainer>
        {showClear ? (
          <SearchInputButton showHandCursor={true} onClick={clearInput}>
            <X size='20' />
          </SearchInputButton>
        ) : (
          <SearchInputButton>
            <Search />
          </SearchInputButton>
        )}
      </SearchInputIconContainer>
    </SearchInputStyled>
  );
};
